// component
import SvgColor from '../../../components/svg-color';
import Iconify from '../../../components/iconify/Iconify';
import { tokenService } from 'src/services';
import { useEffect, useState } from 'react';
import { canAccessEPServiceManagement, canAccessProgressPayment, canAccessDHLShipments } from 'src/utils/accessControl';

// ----------------------------------------------------------------------

const icon = (name) => <Iconify icon={name} sx={{ width: 1, height: 1 }} />;

const useNavConfig = () => {
  const [navConfig, setNavConfig] = useState([]);

  useEffect(() => {
    const user = tokenService.getUser();
    if (user) {
      const canViewEPServiceManagement = canAccessEPServiceManagement(user);
      const canViewDHLShipments = canAccessDHLShipments(user);
      const canViewProgressPayment = canAccessProgressPayment(user);
      const points = Object.values(user?.allowedPoints || {});
      const inventories = points.map(
        (p) => p.details.vehicleInventoryWithPrice || {}
      );
      const isCDEK = user?.isCDEK === true;
      const hasKidCar = inventories.some((inv) => inv['kid-car'] !== undefined);
      const hasGift = inventories.some((inv) => inv['gift'] !== undefined);
      const hasPetCar = inventories.some((inv) => inv['pet-car'] !== undefined);

      setNavConfig([
        {
          title: 'Ana Sayfa',
          path: '/dashboard/app',
          icon: icon('ep:menu'),
          permissions: [
            'false:false',
            'user:false',
            'user:operations',
            'user:manager',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Tüm Gönderiler',
          path: '/dashboard/all-posts',
          icon: icon('ri:file-list-2-line'),
          permissions: [
            'false:false',
            'user:false',
            'user:operations',
            'user:manager',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'İstatistikler',
          path: '/dashboard/stats',
          icon: icon('ri:line-chart-line'),
          permissions: [
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'EP App Gönderileri',
          path: '/dashboard/ep-app-posts',
          icon: icon('ri:file-list-2-line'),
          permissions: [
            'user:false',
            'user:operations',
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        // {
        //   title: 'Vestiyer İşlemleri',
        //   path: '/dashboard/checkroom-operations',
        //   icon: icon('tabler:truck-loading'),
        //   permissions: [
        //     'user:false',
        //     'user:operations',
        //     'user:manager',
        //     'highadmin:manager',
        //     'highadmin:operations',
        //     'admin:manager',
        //     'admin:operations',
        //     'admin:EP',
        //     'superadmin:manager',
        //     'superadmin:operations',
        //   ],
        //   category: 'Yönetim',
        // },
        ...(hasKidCar
          ? [
              {
                title: 'Çocuk Araçları',
                path: '/dashboard/kid-vehicles',
                icon: icon('tabler:horse-toy'),
                permissions: [
                  'user:false',
                  'user:operations',
                  'user:manager',
                  'highadmin:manager',
                  'highadmin:operations',
                  'admin:manager',
                  'admin:operations',
                  'admin:EP',
                  'superadmin:manager',
                  'superadmin:operations',
                ],
                category: 'Yönetim',
              },
            ]
          : []),

        ...(hasPetCar
          ? [
              {
                title: 'Evcil Hayvan Araçları',
                path: '/dashboard/pet-vehicles',
                icon: icon('mdi:paw-outline'),
                permissions: [
                  'user:false',
                  'user:operations',
                  'user:manager',
                  'highadmin:manager',
                  'highadmin:operations',
                  'admin:manager',
                  'admin:operations',
                  'admin:EP',
                  'superadmin:manager',
                  'superadmin:operations',
                ],
                category: 'Yönetim',
              },
            ]
          : []),

        ...(hasGift
          ? [
              {
                title: 'Hediye Paketleri',
                path: '/dashboard/gift-packages',
                icon: icon('qlementine-icons:gift-16'),
                permissions: [
                  'user:false',
                  'user:operations',
                  'user:manager',
                  'highadmin:manager',
                  'highadmin:operations',
                  'admin:manager',
                  'admin:operations',
                  'admin:EP',
                  'superadmin:manager',
                  'superadmin:operations',
                ],
                category: 'Yönetim',
              },
            ]
          : []),
        {
          title: 'Kargo Partner İşlemleri',
          path: '/dashboard/cargo-partner-operations',
          icon: icon('la:truck'),
          permissions: [
            'false:false',
            'user:false',
            'user:operations',
            'user:manager',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        ...(canViewDHLShipments
          ? [
              {
                title: 'DHL Gönderileri',
                path: '/dashboard/dhl-shipments',
                icon: icon('mdi:package-variant-closed'),
                permissions: [
                  'highadmin:false',
                  'highadmin:manager',
                  'highadmin:operations',
                ],
                category: 'Yönetim',
              },
            ]
          : []),
        {
          title: 'Kurye - Kargo (Desk)',
          path: '/dashboard/courier-cargo',
          icon: icon('la:truck'),
          permissions: [
            'false:false',
            'user:false',
            'user:operations',
            'user:manager',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Kurye - Kargo (Esnaf)',
          path: '/dashboard/courier-cargo/esnaf',
          icon: icon('la:truck'),
          permissions: [
            'false:false',
            'user:false',
            'user:operations',
            'user:manager',
            'esnaf:true',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Kurye - Kargo Cari İşlemleri',
          path: '/dashboard/courier-cargo-order-report',
          icon: icon('la:truck'),
          permissions: [
            'false:false',
            'user:false',
            'user:operations',
            'user:manager',
            'esnaf:true',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        ...(isCDEK
          ? [
              {
                title: 'CDEK Operasyonları',
                path: '/dashboard/cdek-operations',
                icon: icon('la:truck'),
                permissions: [
                  'false:false',
                  'user:false',
                  'user:operations',
                  'user:manager',
                  'esnaf:true',
                  'esnaf:operations',
                  'highadmin:manager',
                  'highadmin:operations',
                  'admin:manager',
                  'admin:operations',
                  'admin:EP',
                  'admin:EPS',
                  'superadmin:manager',
                  'superadmin:operations',
                ],
                category: 'Yönetim',
              },
            ]
          : []),
        {
          title: 'Hands Free İşlemleri',
          path: '/dashboard/hands-free',
          icon: icon('ph:hand-palm'),
          permissions: [
            'false:false',
            'user:false',
            'user:operations',
            'user:manager',
            'esnaf:true',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Operasyon Kullanıcı Listesi',
          path: '/dashboard/users',
          icon: icon('ph:users'),
          permissions: [
            // 'user:operations',
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
            // 'false:operations',
            // 'false:manager',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Noktalar',
          path: '/dashboard/points',
          icon: icon('ph:map-pin-bold'),
          permissions: [
            // 'user:operations',
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
            // 'false:operations',
            // 'false:manager',
          ],
          category: 'Yönetim',
        },
        // {
        //   title: 'Emanet Dolap Raporu',
        //   path: '/dashboard/monthly-cabine',
        //   icon: icon('mdi:report-box-outline'),
        //   permissions: ['user:manager'],
        // },
        {
          title: 'Vestiyer Listesi',
          path: '/dashboard/checkroom',
          icon: icon('ri:file-list-2-line'),
          permissions: [
            'user:operations',
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'superadmin:manager',
            'superadmin:operations',
            'user:false',
            // 'false:manager',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Easy Point Hizmetleri',
          path: '/dashboard/easypoint-services',
          icon: icon('ri:file-list-2-line'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Kuponlar',
          path: '/dashboard/coupons',
          icon: icon('mdi:ticket-percent-outline'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Easy Point Hizmetleri Raporu',
          path: '/dashboard/services-report',
          icon: icon('ri:file-list-2-line'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        ...(canViewEPServiceManagement
          ? [
              {
                title: 'EP Hizmet Yönetimi',
                path: '/dashboard/easypoint-service-management',
                icon: icon('ri:file-list-2-line'),
                permissions: [
                  'highadmin:manager',
                  'highadmin:operations',
                  'superadmin:manager',
                  'superadmin:operations',
                ],
                category: 'Yönetim',
              },
              {
                title: 'Easy Desk İşlemleri',
                path: '/dashboard/ep-bulk-service-management',
                icon: icon('ri:table-2'),
                permissions: [
                  'highadmin:manager',
                  'highadmin:operations',
                  'superadmin:manager',
                  'superadmin:operations',
                ],
                category: 'Yönetim',
              },
            ]
          : []),
        // {
        //   title: 'Dolap Takip Sistemi',
        //   path: '/dashboard/locker-track-system',
        //   icon: icon('ri:file-list-2-line'),
        //   permissions: [
        //     'highadmin:manager',
        //     'highadmin:operations',
        //     // 'false:manager',
        //   ],
        //   category: 'Yönetim',
        // },
        {
          title: 'Dolap Takip Sistemi',
          path: '/dashboard/locker-tracking-system',
          icon: icon('ri:file-list-2-line'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'highadmin:false',
            'superadmin:manager',
            'superadmin:operations',
            'superadmin:false',
            'admin:can-view-lockers',
            'user:can-view-lockers',
            // 'user:operations',
            // 'false:manager',
          ],
          category: 'Yönetim',
        },
        {
          title: 'AVM Listesi',
          path: '/dashboard/mall-list',
          icon: icon('ri:file-list-2-line'),
          permissions: [
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'superadmin:manager',
            'superadming:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Saha Raporu',
          path: '/dashboard/fast-report',
          icon: icon('teenyicons:clipboard-plus-outline'),
          permissions: [
            'user:operations',
            'user:manager',
            'false:false',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'superadmin:manager',
            'superadmin:operations',
            // 'esnaf:false',
            // 'esnaf:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Saha Raporu Listesi',
          path: '/dashboard/fast-report-list',
          icon: icon('teenyicons:clipboard-plus-outline'),
          permissions: [
            'user:operations',
            'user:manager',
            'false:false',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'superadmin:manager',
            'superadmin:operations',
            // 'esnaf:false',
            // 'esnaf:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Rapor Oluştur',
          path: '/dashboard/create-report',
          icon: icon('lets-icons:file-dock-add'),
          permissions: [
            // 'user:operations',
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
            // 'user:false',
            // 'false:false',
          ],
          category: 'Yönetim',
        },

        {
          title: 'Emanet Raporu',
          path: '/dashboard/emanet-report',
          icon: icon('lets-icons:file-dock-add'),
          permissions: [
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Log Arama',
          path: '/dashboard/log-search',
          icon: icon('et:search'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Talep Formları',
          path: '/dashboard/contact-forms',
          icon: icon('et:search'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Yönetim',
        },
        {
          title: 'Emanet Dolap Yönetimi',
          path: '#',
          icon: icon('mdi:locker-multiple'),
          category: 'Yönetim',          
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
          ],
          children: [
            {
              title: 'Dolap İşlemleri',
              path: '/dashboard/box-operations',
              permissions: ['highadmin:manager', 'highadmin:operations'],
            },
            {
              title: 'Dolap Detayları',
              path: '/dashboard/box-details',
              permissions: ['highadmin:manager', 'highadmin:operations'],
            },
            {
              title: 'Dolap Durumu',
              path: '/dashboard/box-status',
              permissions: ['highadmin:manager', 'highadmin:operations'],
            },
            {
              title: 'SMS Gönderme',
              path: '/dashboard/box-sending-sms',
              permissions: ['highadmin:manager', 'highadmin:operations'],
            },
            {
              title: 'Kupon Yönetimi',
              path: '/dashboard/box-operations-coupons',
              permissions: ['highadmin:manager', 'highadmin:operations'],
            },
          ],
        },
        {
          title: 'Bol Para',
          path: '/dashboard/bol-para',
          icon: icon('mdi:hand-coin-outline'),
          permissions: [
            // 'user:operations',
            //'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'superadmin:manager',
            'superadmin:operations',
            // 'user:false',
            // 'false:false',
            // 'esnaf:false',
            // 'esnaf:operations',
          ],
          category: 'Bol Para',
        },
        {
          title: 'Bol Para Başvurular',
          path: '/dashboard/bol-para-applications',
          icon: icon('uil:file-check-alt'),
          permissions: [
            //'user:operations',
            //'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'superadmin:manager',
            'superadmin:operations',
            // 'user:false',
            // 'false:false',
            // 'esnaf:false',
            // 'esnaf:operations',
          ],
          category: 'Bol Para',
        },
        {
          title: 'Toplu Başvuru Güncelleme',
          path: '/dashboard/bol-para-request-management',
          icon: icon('uil:file-check-alt'),
          permissions: [
            //'user:operations',
            //'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'superadmin:manager',
            'superadmin:operations',
            // 'user:false',
            // 'false:false',
            // 'esnaf:false',
            // 'esnaf:operations',
          ],
          category: 'Bol Para',
        },
        {
          title: 'Bol Para Esnaf',
          path: '/dashboard/bol-para-esnaf',
          icon: icon('uil:file-check-alt'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'superadmin:manager',
            'superadmin:operations',
            'esnaf:operations',
          ],
          category: 'Bol Para',
        },
        {
          title: 'Kampanyalar',
          path: '/dashboard/campaign',
          icon: icon('mage:gift'),
          permissions: [
            //'user:operations',
            //'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'superadmin:manager',
            'superadmin:operations',
            // 'user:false',
            // 'false:false',
            // 'esnaf:false',
            // 'esnaf:operations',
          ],
          category: 'Bol Para',
        },
        {
          title: 'Başvuru Listesi',
          path: '/dashboard/campaign-applications',
          icon: icon('uil:file-check-alt'),
          permissions: [
            //'user:operations',
            //'user:manager',
            'user:marketing',
            'highadmin:marketing',
            'superadmin:marketing',
            'highadmin:manager',
            'highadmin:operations',
            // 'admin:manager',
            // 'admin:operations',
            'superadmin:manager',
            'superadmin:operations',
            // 'user:false',
            // 'false:false',
            // 'esnaf:false',
            // 'esnaf:operations',
          ],
          category: 'Bol Para',
        },
        {
          title: 'Teknik Destek Talepleri',
          path: '/dashboard/support-tickets',
          icon: icon('hugeicons:customer-support'),
          permissions: [
            'user:operations',
            'user:manager',
            'user:false',
            'false:false',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Destek',
        },
        {
          title: 'Güncelleme Notları',
          path: '/dashboard/update-reports',
          icon: icon('hugeicons:note'),
          permissions: [
            'user:operations',
            'user:manager',
            'user:false',
            'false:false',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Destek',
        },
        {
          title: 'Hak Ediş Raporu',
          path: '/dashboard/earn-report',
          icon: icon('hugeicons:note'),
          permissions: [
            // 'user:operations',
            // 'user:manager',
            // 'user:false',
            // 'false:false',
            // 'esnaf:false',
            // 'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            // 'admin:manager',
            // 'admin:operations',
            // 'admin:EP',
            // 'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Destek',
        },
        canViewProgressPayment && {
          title: 'Hak Ediş Yönetimi',
          path: '/dashboard/hakedis-management',
          icon: icon('mdi:file-document-edit-outline'),
          permissions: [
            'user:manager',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Destek',
        },
        {
          title: 'Bildirim Sistemi',
          path: '/dashboard/notification-management',
          icon: icon('hugeicons:note'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Destek',
        },
        {
          title: 'Esnaf Eğitimi',
          path: '/dashboard/esnaf-tutorial',
          icon: icon('mdi:cast-tutorial'),
          permissions: [
            'user:operations',
            'user:manager',
            'user:false',
            'false:false',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Eğitim Bölümü',
        },
        {
          title: 'Bol Para Eğitimi',
          path: '/dashboard/bolpara-tutorial',
          icon: icon('mdi:cast-tutorial'),
          permissions: [
            'user:operations',
            'user:manager',
            'user:false',
            'false:false',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Eğitim Bölümü',
        },
        {
          title: 'AVM Saha Eğitimi',
          path: '/dashboard/user-tutorial',
          icon: icon('mdi:cast-tutorial'),
          permissions: [
            'user:operations',
            'user:manager',
            'user:false',
            'false:false',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Eğitim Bölümü',
        },
        // {
        //   title: 'Porter Eğitimi',
        //   path: '/dashboard/porter-tutorial',
        //   icon: icon('mdi:cast-tutorial'),
        //   permissions: [
        //     'user:operations',
        //     'user:manager',
        //     'user:false',
        //     'false:false',
        //     'esnaf:false',
        //     'esnaf:operations',
        //     'highadmin:manager',
        //     'highadmin:operations',
        //     'admin:manager',
        //     'admin:operations',
        //     'admin:EP',
        //     'admin:EPS',
        //     'superadmin:manager',
        //     'superadmin:operations',
        //   ],
        //   category: 'Eğitim Bölümü',
        // },

        {
          title: 'Sıkça Sorulan Sorular (SSS)',
          path: '/dashboard/faq',
          icon: icon('wpf:faq'),
          permissions: [
            'user:operations',
            'user:manager',
            'user:false',
            'false:false',
            'esnaf:false',
            'esnaf:operations',
            'highadmin:manager',
            'highadmin:operations',
            'admin:manager',
            'admin:operations',
            'admin:EP',
            'admin:EPS',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Eğitim Bölümü',
        },
        {
          title: 'Sıkça Sorulan Sorular Yönetimi',
          path: '/dashboard/faq-management',
          icon: icon('wpf:faq'),
          permissions: [
            'highadmin:manager',
            'highadmin:operations',
            'superadmin:manager',
            'superadmin:operations',
          ],
          category: 'Eğitim Bölümü',
        },
      ].filter(Boolean));
    }
  }, []);

  return navConfig;
};

export default useNavConfig;
